export default "__VITE_ASSET__22636d8a__"